var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 360 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-8{fill:#8258f3;}.cls-2{opacity:0.1;}.cls-3{fill:#f6f7fa;}.cls-4{fill:#f3f2f7;}.cls-5{fill:#fff;}.cls-6{fill:#e4e4e4;}.cls-7{mix-blend-mode:multiply;opacity:0.25;}.cls-9{fill:#f35e9a;}.cls-10{fill:url(#Degradado_sin_nombre_4);}.cls-11{fill:url(#Degradado_sin_nombre_4-2);}.cls-12{fill:url(#Degradado_sin_nombre_4-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4",
    x1: 194.12,
    y1: 122.62,
    x2: 274.61,
    y2: 122.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7187e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b198f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-2",
    x1: 205.85,
    y1: 114.82,
    x2: 209.43,
    y2: 114.82,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-3",
    x1: 207.97,
    y1: 104.82,
    x2: 239.76,
    y2: 104.82,
    xlinkHref: "#Degradado_sin_nombre_4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M272,97.6c-17,.5-21.8,7.9-48.8,6.7-21.5-1-30.9,8-32.1,13.9s6.2,18.8,40.2,12c38.6-7.7,55.9,15.4,75.2-7.8C314.5,112.9,310.5,96.3,272,97.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a979eff9-2035-45aa-8fad-490bbaa22894",
    className: "cls-3",
    x: 97.7,
    y: 101.9,
    width: 115.4,
    height: 60.58
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b5344e31-85e8-4079-8f4b-e609523654c2",
    className: "cls-4",
    x: 97.6,
    y: 101.8,
    width: 115.4,
    height: 7.02
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a6983896-3ceb-4bf9-866b-7e40cad74d1b",
    className: "cls-5",
    x: 100.1,
    y: 111.3,
    width: 110.8,
    height: 48.13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "f96e66fe-9216-4da2-bba4-b63d176988a9",
    className: "cls-5",
    cx: 108.6,
    cy: 105.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e3ffbb79-e13a-4bd7-b23c-45510780cb2f",
    className: "cls-5",
    cx: 113,
    cy: 105.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ec6ea03b-7290-43d8-8b25-59bf30f1f0ee",
    className: "cls-5",
    cx: 104.2,
    cy: 105.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 130.6,
    cy: 125.2,
    r: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M172.7,123.2a1.8,1.8,0,0,1,1.8,1.8,1.8,1.8,0,0,1-1.8,1.7H145.1a1.8,1.8,0,0,1-1.8-1.7,1.8,1.8,0,0,1,1.8-1.8h27.6m0-.5H145.1a2.2,2.2,0,0,0-2.2,2.3,2.2,2.2,0,0,0,2.2,2.2h27.6a2.2,2.2,0,0,0,2.2-2.2,2.2,2.2,0,0,0-2.2-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.8,127.2H141.1a2.3,2.3,0,1,1,0-4.5h20.7A2.2,2.2,0,0,1,164,125a2.2,2.2,0,0,1-2.2,2.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 130.6,
    cy: 136.1,
    r: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M172.7,134.1a1.8,1.8,0,0,1,1.8,1.7,1.8,1.8,0,0,1-1.8,1.8H145.1a1.8,1.8,0,0,1-1.8-1.7,1.8,1.8,0,0,1,1.8-1.8h27.6m0-.5H145.1a2.2,2.2,0,0,0-2.2,2.2,2.2,2.2,0,0,0,2.2,2.3h27.6a2.2,2.2,0,0,0,2.2-2.2,2.2,2.2,0,0,0-2.2-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.7,138.1H141.1a2.3,2.3,0,1,1,0-4.5h28.6a2.2,2.2,0,0,1,2.2,2.3A2.2,2.2,0,0,1,169.7,138.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 130.6,
    cy: 147,
    r: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M172.7,145a1.8,1.8,0,0,1,1.8,1.7,1.8,1.8,0,0,1-1.8,1.8H145.1a1.8,1.8,0,0,1-1.8-1.8,1.8,1.8,0,0,1,1.8-1.7h27.6m0-.5H145.1a2.2,2.2,0,0,0-2.2,2.2,2.2,2.2,0,0,0,2.2,2.3h27.6a2.2,2.2,0,0,0,2.2-2.3,2.2,2.2,0,0,0-2.2-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.8,149H141.1a2.3,2.3,0,1,1,0-4.5h31.7a2.2,2.2,0,0,1,2.2,2.2A2.2,2.2,0,0,1,172.8,149Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b0371f3f-df42-4d60-b6c1-6000de199dd5",
    className: "cls-3",
    x: 70,
    y: 17.6,
    width: 122.6,
    height: 64.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a5ec3362-5fc6-49dd-bbc1-e584c03fc30b",
    className: "cls-4",
    x: 69.9,
    y: 17.5,
    width: 122.6,
    height: 7.46
  }), /*#__PURE__*/React.createElement("rect", {
    id: "edb19af0-e7ad-43aa-9651-c68038fb40c2",
    className: "cls-5",
    x: 72.7,
    y: 28,
    width: 117.5,
    height: 50.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "fcfbd1c3-546b-4aa9-92d2-19035f23e7a3",
    className: "cls-5",
    cx: 81.5,
    cy: 21.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "fcf1e260-d16a-4b37-91b5-eb72ad8ee2c7",
    className: "cls-5",
    cx: 86.2,
    cy: 21.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ae552ed4-f0ed-4b8a-a24a-450e5f71adc4",
    className: "cls-5",
    cx: 76.8,
    cy: 21.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 92.7,
    cy: 64.1,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 111.9,
    cy: 58.4,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.1,
    cy: 64.1,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 150.2,
    cy: 35.4,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.4,
    cy: 35.1,
    r: 2.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "131.1 64.5 111.9 58.6 93 64.4 92.5 63.8 111.9 57.7 131 63.6 150 35.1 150.1 35.1 169.3 35 169.5 35.7 150.4 35.7 131.1 64.5"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-7",
    width: 156,
    height: 91,
    transform: "translate(138 34)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJwAAABbCAYAAACGVexBAAAACXBIWXMAAAsSAAALEgHS3X78AAAFCElEQVR4Xu2a7U7cRhSGn4WFBUoimkioVapeGOIKuCCuAHFhVaNWkZJGhMB+uz9mzvrs7Oy6UaXzw34f6cjYHnt/+NF7ZmxGTdMgRBTjrgEld7ePo64xYjjcP9z8UGKNDiVcIVcpmsQbNqU4m/1DElaFc6KNKgWSTSQaty2rKt6OcFk2q6NKlfKJYeLlWleqAZpSui3hCtmOc41d2TETb+teiD5Ta6FrYJVr6cqO7UhXWzSYbGPgNNck1wmteKV0Eq7feOG8bEtgAcxyzXNBK92GTcK5dDPZJsAZcOHqnCTgSR6n1jo8rI2uSKLNgVfgxdWUJJ+l3SblyoSzeZul2wXw1tUlSboJ2ykn6YaBn7OtSFK9As/AE61Pdt7P54DDwk1ohXsPvAOuSNKdkVLOFhJiOJhEC1KSPQNfST5A22IX+e+tMPLC+ZVpKdw74Jok3tt83FJOCTccfDudkdrnE6kbQiuhle+AB1vqMcnYc1KiXZFku6ZNuUm+XsINBxNuSRLumdTtIM3lvgPfaOf4O28zRk3T+AXDON/gDSnVfgF+A34HPuT99/n8GRJuaHjhpiS5PgN/Ax+BP4A/8/6XfH6axzf3DzdNLeHKlPOr1UuSbG9I6Tem/k5O9BNbMCxp52wzkhtntK/O9i4oyzmcbb10XjyT75zthYO/XvQTW2nagoG89e9oyw8D3qnqHM7jxTP5/FcHewmshBsOlnCQUs5/gSo/fVbp+vckL92IXQn9j4j+YylX+67eKRt0Cwe7rbaMys4fEb2iy4eD7Htp+18k6jov+kvXs9/rj74SiFAknAhFwolQJJwIRcKJUCScCEXCiVAknAhFwolQJJwIRcKJUCScCEXCiVAknAhFwolQJJwIRcKJUCScCEXCiVAknAhFwolQJJwIRcKJUCScCEXCiVAknAhFwolQJJwIRcKJUCScCEXCiVAknAhFwolQJJwIRcKJUCScCEXCiVAknAhFwolQJJwIRcKJUCScCEXCiVAknAhFwolQJJwIRcKJUCScCEXCiVAknAhFwolQJJwIRcKJUCScCGWfcE2uQ3SdF/2l69nv9WdcO1jQuK0vOHBj0Utqz748dpAu4exma7ZvvnYFMKpeLfpG+exLJzoD6JBwpVwrYOlqkcdZW5Z0/cZEWpOevXdhxa6EVbxwZVSaZCvSD8xyTYGTPHZJEk6yDQPzYgm8klwwLxa0vpTibQQsE66UzUSbAi/AMzDJYxf5+hESbiiYH0uSE99ITrzQymfiVdNu1DRp/+728Ygk0AT4CfgZuAZ+BT7k7TVwBVzmcRJuWHjhZiTZvgKfgL+Aj3n7CfgH+J7HLe8fbtZQTzifbq/upqd5zBS4IAl3jIQbEibciiTSC/AEfCY58kxypky5DeUczvdof0Obs81JMXqWjx2hl8dDwxYHC1L4WCB9IbnyQk41Km11X8J54WzMghSR57TpZgsGJdwwKOf4M9ou+MR+4TYcEm6eL4btSeIpKd3UToeJb6sLkievJFes5uwRbrNoALi7fRyRUuuYJONprkmuk3zcp9vmXog+48XxKWfvZO31yJxWuBWwvn+42dtSobXX/239+pi6bFT2Rb/YSiq2pSs/Ctix8prthINNylkdVcqfF8OlcbWuVAM0Pt2gIhxspINtubxkkk1Am2BNpShlgz3CGU48UAsV29RaLFAXzTgoXI1CQjFwDslV44eFE+L/8C+Gm97HZlgATQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("rect", {
    id: "e9e5cf6b-8f55-43bf-8281-302b4fb1e9d5",
    className: "cls-4",
    x: 153.3,
    y: 44.1,
    width: 136.9,
    height: 71.86
  }), /*#__PURE__*/React.createElement("rect", {
    id: "e4e8a65e-8422-4898-a810-30d755c7dafc",
    className: "cls-8",
    x: 153.2,
    y: 43.9,
    width: 136.9,
    height: 8.33
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b6acd298-89f8-46a0-ab3e-c2f0533bc288",
    className: "cls-5",
    x: 156.3,
    y: 54.8,
    width: 130.5,
    height: 57.07
  }), /*#__PURE__*/React.createElement("circle", {
    id: "a2e6f9e4-3ad4-420f-8fe3-197d901d1e70",
    className: "cls-4",
    cx: 166.1,
    cy: 48.1,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b303a717-eadc-4672-a419-54a1feb6afd8",
    className: "cls-4",
    cx: 171.4,
    cy: 48.1,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b1ff2c46-8045-41fc-afe2-76f8fb520d89",
    className: "cls-4",
    cx: 160.9,
    cy: 48.1,
    r: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.5,67.3a1.2,1.2,0,0,0,0,2.3h46.2a1.2,1.2,0,0,0,1-1.3,1.3,1.3,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.5,93.7a1.2,1.2,0,0,0,0,2.3h46.2a1.2,1.2,0,0,0,1-1.3,1.3,1.3,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.5,74a1.2,1.2,0,0,0,0,2.3h19.9a1.2,1.2,0,0,0,0-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.5,80.4a1.2,1.2,0,0,0,0,2.3h46.2a1.2,1.2,0,0,0,1-1.3,1.3,1.3,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.5,87.2a1.1,1.1,0,0,0-1,1.2,1.3,1.3,0,0,0,1,1h19.9a1.3,1.3,0,0,0,1-1.3,1.1,1.1,0,0,0-1-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.6,94.7a1.1,1.1,0,0,0,1.1-1,1.1,1.1,0,0,0-1.1-1.1H174a1.1,1.1,0,0,0-1.1,1.1,1,1,0,0,0,1.1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.6,88.5a1.1,1.1,0,0,0,0-2.2H174a1.1,1.1,0,0,0,0,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M184.8,68.6a6.7,6.7,0,1,1-6.7,6.7h0A6.7,6.7,0,0,1,184.8,68.6Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-7",
    width: 93,
    height: 84,
    transform: "translate(187 84)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M242.1,93.4a29.6,29.6,0,1,0,1.3,45.4l24.3,19.1a1.4,1.4,0,0,0,2-.3h0l4.6-5.8a1.4,1.4,0,0,0-.2-2h0l-24.3-19.1A29.7,29.7,0,0,0,242.1,93.4Zm-1.7,36.4a21.2,21.2,0,1,1-3.6-29.8,21.3,21.3,0,0,1,3.6,29.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M207.4,113c-2.4.3-1.9,4,.5,3.7A1.9,1.9,0,0,0,207.4,113Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M222.2,99a17.7,17.7,0,0,0-14.1,9.9c-.8,1.7,2.2,2.7,3,1a14.8,14.8,0,0,1,11.8-8.1,16.1,16.1,0,0,1,14.1,5.8c1.2,1.5,3.7-.4,2.4-1.9A19.5,19.5,0,0,0,222.2,99Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.fba65ab5e05661306591ef2cf0d9f7b7.svg";
export { ForwardRef as ReactComponent };